import { Component, OnInit } from '@angular/core';
import { Router, Params } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivityService } from '../../common/activity.service';
import { ActivityQuestionFormComponent } from '../activity-question-form/activity-question-form.component';
import { ActivityQuestionOptionsComponent } from '../activity-question-options/activity-question-options.component';
import { MdDialog } from '@angular/material';

@Component({
  selector: 'activity-questions',
  templateUrl: './activity-questions.component.html',
  styleUrls: ['./activity-questions.component.css', '../../app.component.css'],
  providers: [ActivityService]
})
export class ActivityQuestionsComponent implements OnInit {

  eventId: any;
  activityId: any;
  parentOptionId: any;
  activityQuestions: any;
  activityQuestionId: any;
  activityQuestion: any;
  spinner: boolean = false;

  constructor(private formBuilder: FormBuilder, private activityService: ActivityService, public dialog: MdDialog){
  }

  ngOnInit() {
  }

  getActivityQuestions(){
   this.spinner = true;
   this.activityService.getActivityQuestions({activityId : this.activityId}).subscribe(
    response => {
     this.spinner = false;
     this.activityQuestions = response;
    },
    error => {
     this.spinner = false;
    }
   );
  }

  activityQuestionFormDialog(params) {
    this.spinner = true;
    if(params && params.id)
    this.activityQuestionId = params.id;
    else
    this.activityQuestionId = 0;
    let dialogRef = this.dialog.open(ActivityQuestionFormComponent);
    dialogRef.componentInstance.eventId = this.eventId;
    dialogRef.componentInstance.activityId = this.activityId;
    if(this.activityQuestionId)
    {
     this.activityService.findActivityQuestion(this.activityQuestionId).subscribe(
      response => {
       this.spinner = false;
       dialogRef.componentInstance.activityQuestion = response[0];
      },
      error => {
       this.spinner = false;
      }
     );
    }
    else
    dialogRef.componentInstance.activityQuestion = dialogRef.componentInstance.activityQuestionForm.value;
    dialogRef.componentInstance.onSave.subscribe(() => {
     this.getActivityQuestions();
     dialogRef.close();
    });
  }

  deleteActivityQuestion(params){
   if(confirm('Are you sure?'))
   {
    this.spinner = true;
    this.activityService.deleteActivityQuestion(params).subscribe(
     response => {
      this.spinner = false;
      if(response.status)
      this.getActivityQuestions();
     },
     error => {
      this.spinner = false;
     }
    );
   }
  }

  activityQuestionOptionsDialog(params) {
    this.activityQuestionId = params.id;
    let dialogRef = this.dialog.open(ActivityQuestionOptionsComponent);
    dialogRef.componentInstance.activityId = this.activityId;
    dialogRef.componentInstance.activityQuestionId = this.activityQuestionId;
    dialogRef.componentInstance.getActivityQuestionOptions();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/activity-questions/activity-questions.component.ts